import script from "./OvertimeWorkHourLimitForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OvertimeWorkHourLimitForm.vue?vue&type=script&setup=true&lang=js"

import "./OvertimeWorkHourLimitForm.vue?vue&type=style&index=0&id=56cf846c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56cf846c"]])

export default __exports__